import React from 'react';
import flatten from 'flat';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  errors: { [field: string]: string | undefined | { [field: string]: string } };
}

function PageFormErrorMessage({ errors }: Props) {
  const classes = useStyles();

  if (!errors) {
    return null;
  }

  const errorList = Object.values(flatten(errors));
  const firstErrorMessage = errorList[0] as string;

  return (
    <div className={classes.root}>
      {errorList.length > 1
        ? `There are ${errorList.length} errors in your form.`
        : firstErrorMessage}
    </div>
  );
}

const useStyles = makeStyles(theme => {
  return {
    root: {
      textAlign: 'right',
      marginRight: theme.spacing(2),
    },
  };
});

export default PageFormErrorMessage;
